import React from 'react';

const Vue_Forms = () => {
  return (
    <div>
      <h1>Vue_Forms Component</h1>
      <p>This is the Vue_Forms tutorial page.</p>
    </div>
  );
}

export default Vue_Forms;
